import { StateCreator } from 'zustand'
import { AppSlice, AppSliceState } from '@/types/store.types'

export const appSliceDefault: AppSlice = {
  ready: false,
  siteIsVisible: true,
  userIsIdle: false,
}

export const createAppSlice: StateCreator<AppSliceState, [], [], AppSliceState> = (set) => ({
  ...appSliceDefault,
  updateUserIsIdle: (userIsIdle: boolean) => set({ userIsIdle }),
  setReady: (ready: boolean) => set({ ready }),
  setSiteIsVisible: (siteIsVisible: boolean) => set({ siteIsVisible }),
  setUserIsIdle: (userIsIdle: boolean) => set({ userIsIdle }),
})
